export const buttonColor = (colorMode: string) => (colorMode === "dark" ? "default" : "primary");
